export const SEND_ADMIN_OTP =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/forgot-password";
export const SEND_OTP =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "auth/forgot-password";
export const SEND_CLIENT_OTP =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "auth/forgot-password";
export const LOGIN =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/login";
export const CLIENT_LOGIN =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "auth/login";
export const CREATE_PASSWORD =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/password";
export const RESET_PASSWORD =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/reset-password";

export const RESET_CLIENT_PASSWORD =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "auth/reset-password";

export const CREATE_CLIENT_PASSWORD =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "auth/update-password";
export const GET_COUNTRIES = "country";
export const GET_CURRENCIES = "country/currencies";
export const GET_STATES = "country/states";
export const GET_LGAS = "country/state-lgas";

export const GET_USER = "account/user";
export const ONBOARD_CLIENT = "admin/auth/onboard-client";
export const ADD_STAFF = "admin/auth/admin-member";

// KYBS
export const ADMIN_CORPORATE_KYC_LIST = "admin/corporate-kyb/kyc-verifications";
export const ADMIN_INDIVIDUAL_KYC_LIST =
  "admin/individual-kyb/kyc-verifications";
export const REVIEW_CORP_KYB = "admin/corporate-kyb/review-kyb";
export const REVIEW_IND_KYB = "admin/individual-kyb/review-kyb";
export const GET_CORP_BUS_INFO = "admin/corporate-kyb/business-information";
export const GET_CORP_FIN_DETAILS = "admin/corporate-kyb/financial-details";
export const GET_CORP_RISK = "admin/corporate-kyb/risk-assessment";
export const GET_CORP_DOC_1 = "admin/corporate-kyb/document-Uploads1";
export const GET_CORP_DOC_2 = "admin/corporate-kyb/document-uploads2";
export const GET_INDIVIDUAL_BUS_INFO =
  "admin/individual-kyb/business-information";
export const GET_INDIVIDUAL_FIN_DETAILS =
  "admin/individual-kyb/financial-details";
export const GET_INDIVIDUAL_RISK = "admin/individual-kyb/risk-assessment";
export const GET_INDIVIDUAL_DOC = "admin/individual-kyb/document-Uploads";
export const CORPORATE_BUSINESS_INFORMATION =
  "corporate-kyb/bussiness-information";
export const CORPORATE_FINANCIAL_DETAILS = "corporate-kyb/finance-details";
export const CORPORATE_RISK_ASSESSMENT = "corporate-kyb/risk-assessment";
export const CORPORATE_DOCUMENT_1 = "corporate-kyb/upload-documents1";
export const CORPORATE_DOCUMENT_2 = "corporate-kyb/upload-documents2";
export const INDIVIDUAL_BUSINESS_INFORMATION =
  "individual-kyb/bussiness-information";
export const INDIVIDUAL_FINANCIAL_DETAILS = "individual-kyb/finance-details";
export const INDIVIDUAL_RISK_ASSESSMENT = "individual-kyb/risk-assessment";
export const INDIVIDUAL_DOCUMENT = "individual-kyb/upload-documents";
export const DELETE_KYC = (orgId) => `admin/corporate-kyb/kyc?orgId=${orgId}`;

// SETTINGS
export const ALL_PERMISSIONS = "admin/permissions?pageNumber=1&pageSize=300";
export const GET_ROLES = "admin/auth/roles";
export const GET_ROLE = "admin/auth/role";
export const ADD_ROLE = "admin/permissions/assign-permissions-to-role";
export const EDIT_ROLE = "admin/permissions/role-permissions";
export const GET_ALL_ADMINS = "admin/auth/admin-members";
export const DELETE_STAFF = (userId = "") => `admin/auth/admin/${userId}`;
export const DEACTIVATE_ADMIN = (userId = "") =>
  `admin/auth/deactivate?userId=${userId}`;
export const RESEND_INVITE = "admin/auth/resend-admin-onboard-mail";
export const REACTIVATE_ADMIN = (userId = "") =>
  `admin/auth/activate?userId=${userId}`;
export const GET_ALL_DEPTS = "admin/designation";
export const GET_DEPT = "admin/designation";
export const ADD_DEPT = "admin/designation";
export const UPDATE_DEPT = "admin/designation";
export const DELETE_DEPT = (id) => `admin/designation/${id}`;

// TRANSACTIONS
export const GET_ALL_TRANSACTIONS = "admin/transaction";
export const GET_ALL_PREAPPROVALS = "admin/pre-approval";
export const INITIATE_TRANSACTIONS = "admin/transaction/initiate-transaction";
export const UPDATE_TRANSACTION = (transactionId = "") =>
  `admin/transaction/${transactionId}`;
export const INITIATE_PREAPPROVAL = "admin/pre-approval/initiate";
export const UPDATE_PREAPPROVAL = (preApprovalTransactionId = "") =>
  `admin/pre-approval/${preApprovalTransactionId}`;
export const GET_DYNAMICS = "admin/trade-dynamics";
export const APPROVE_TRANSACTIONS = "admin/transaction/approve-transaction";
export const APPROVE_PRE = (preApprovalTransactionId = "") =>
  `/admin/pre-approval/${preApprovalTransactionId}/update-approval`;
export const REVENUE = "admin/transaction/overall-revenue";
export const DAILY_VOLUME = "admin/transaction/daily-volume";
export const BANKS = "bank/get-all-banks";

export const NOTIFICATIONS = "admin/auth/notifications";
export const AUDIT = "/audit-log";
